import { render } from "./ViewerForm.vue?vue&type=template&id=16b0bb98"
import script from "./ViewerForm.vue?vue&type=script&lang=js"
export * from "./ViewerForm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__